import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { useSidebarTheme } from 'src/legacy/components/Sidebar/useSidebarTheme';
import { NonHoverBorder, SidebarColors } from 'src/theme/colors';

export const useNotificationBadgeData = (isSidebar: boolean = false) => {
  const { sidebarTheme } = useSidebarTheme();
  const isClient = useSelector((state: RootState) => state.user.isClient);

  // Calculate colors based on user type and context
  const backgroundColor = isSidebar
    ? isClient
      ? sidebarTheme.sidebarTextColor
      : NonHoverBorder
    : 'var(--primary-color, #1976d2)'; // Default primary color

  const textColor = isSidebar
    ? isClient
      ? sidebarTheme.sidebarBackgroundColor
      : SidebarColors.InternalSidebarText
    : 'var(--primary-contrast-text, #ffffff)'; // Default contrast text

  return {
    backgroundColor,
    textColor,
  };
};
